import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const CheckboxSvg = /* @__PURE__ */ __name(() => /* @__PURE__ */ React.createElement("svg", {
  className: "mds-switch-icon-checkbox",
  fill: "none",
  viewBox: "0 0 20 20"
}, /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-switch-svg-box-fill)",
  height: "18",
  rx: "4",
  stroke: "var(--mds-switch-svg-box-stroke)",
  strokeWidth: "2",
  width: "18",
  x: "1",
  y: "1"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M15 11H5V9H15V11Z",
  fill: "var(--mds-switch-svg-indicator-fill)",
  opacity: "var(--mds-switch-svg-indicator-mixed)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M15.2071 7.20706L8.50001 13.9142L4.79291 10.2071L6.20712 8.79285L8.50001 11.0857L13.7929 5.79285L15.2071 7.20706Z",
  fill: "var(--mds-switch-svg-indicator-fill)",
  opacity: "var(--mds-switch-svg-indicator-true)"
})), "CheckboxSvg");

export { CheckboxSvg };
//# sourceMappingURL=checkbox-svg.js.map
